if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        const loadingSpinner = opener.querySelector('.loading__spinner');
        if (loadingSpinner) loadingSpinner.classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then(async (responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            await Promise.all(Array.from(responseHTML.querySelectorAll('link[rel="stylesheet"][href*="/compiled_assets/"]')).map((source) => {
              if (Array.from(document.querySelectorAll('link[rel="stylesheet"]')).some((link) => link.href === source.href)) return;
              return new Promise((resolve, reject) => {
                const link = source.cloneNode(true);
                link.onload = resolve;
                link.onerror = reject;
                document.head.appendChild(link);
              });
            }));
            const productElement = responseHTML.querySelector('section[id^="MainProduct-"]');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.innerHTML);

            const infoWrapper = this.modalContent.querySelector('.product__info-wrapper');
            infoWrapper.style.position = 'sticky';
            infoWrapper.style.boxShadow = 'initial';
            infoWrapper.style.overflowY = 'initial';
            infoWrapper.classList.add('ready'); // 触发显示
            
            const price_item = this.modalContent.querySelector('.price-item.price-item--sale');
            // const price_item_last = this.modalContent.querySelector('.price-item--last .price-item');
            if (price_item && window.innerWidth < 749) {
              price_item.style.fontSize = '3.8rem';
            } else if (price_item) {
              price_item.style.fontSize = '4.3rem';
            }
            

            // ==== 新增：确保 pickup-availability 组件的脚本和样式在弹窗里也能加载 ====
            if (!document.querySelector('link[href*="component-pickup-availability.css"]')) {
              const pickupCss = document.createElement('link');
              pickupCss.rel = 'stylesheet';
              pickupCss.href = '{{ "component-pickup-availability.css" | asset_url }}';
              document.head.appendChild(pickupCss);
            }

            if (!document.querySelector('script[src*="pickup-availability.js"]')) {
              const script = document.createElement('script');
              script.src = '{{ "pickup-availability.js" | asset_url }}';
              script.defer = true;
              document.body.appendChild(script);
            }

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            this.bindProductChangeCallbacks();
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      bindProductChangeCallbacks() {
        const swapProductUtility = this.querySelector('variant-selects')?.swapProductUtility;
        if (swapProductUtility) {
          swapProductUtility.addPreProcessCallback(this.preprocessHTML.bind(this));
          swapProductUtility.addPostProcessCallback(() => {
            this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
            this.bindProductChangeCallbacks();
          });
        }
      }

      preprocessHTML(productElement) {
        // 背景色、渐变色处理
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });

        this.preventDuplicatedIDs(productElement);
        const title = productElement.querySelector('.product__title');
        const subtitle = title?.querySelector('.product__subtitle');
        const titleLink = title?.querySelector('a.product__title');
        if (subtitle && titleLink) title.insertBefore(titleLink, subtitle);
        // 下面这几行是原来直接删东西的，现在要保留 delivery_date 和 pickup-availability
        // this.removeDOMElements(productElement);   // ← 注释掉或删除这行！！！

        // 新增：只删除真正的“干扰项”，保留 delivery 和 pickup-availability
        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        modalDialog.forEach((modal) => modal.remove());

        // 保留 pickup-availability（预计送达日期依赖它）
        // const pickupAvailability = productElement.querySelector('pickup-availability');
        // if (pickupAvailability) pickupAvailability.remove();   // ← 删掉这行！

        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        const variantPicker = productElement.querySelector('variant-selects');
        if (!variantPicker) return;
        variantPicker.setAttribute('data-update-url', 'false');
      }

      // removeDOMElements(productElement) {   // ← 这整个函数可以直接删除了
      //   ... 原有代码全部删除
      // }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;
        productElement.innerHTML = productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        productElement.querySelectorAll('variant-selects, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;
        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
